import React from 'react';
import { TabbedShowLayout, Tab, TextField, ReferenceField, BooleanField } from 'react-admin';

import Show from '../common/views/Show';
import DateFieldCustom from '../common/fields/DateField';
import BudgetTypeField from './fields/BudgetTypeField';

const BudgetShow = props => (
    <Show {...props}>
        <TabbedShowLayout>
            <Tab label="Summary">
                <TextField source="id" />
                <ReferenceField label="Customer" source="customer_id" reference="customers" link="show" allowEmpty>
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label="Project" source="project_id" reference="projects" link="show" allowEmpty>
                    <TextField source="name" />
                </ReferenceField>

                <BudgetTypeField source="budget_type" />

                <TextField source="label" />
                <TextField source="alias" />
                <TextField source="description" />

                <TextField source="hours_included" />
                <TextField source="amount" />

                <DateFieldCustom source="start_date" />
                <DateFieldCustom source="end_date" />

                <BooleanField source="is_active" />
            </Tab>
        </TabbedShowLayout>
    </Show>
);

export default BudgetShow;
